module.exports = __webpack_public_path__ + "img/batterry-alarm.923befea.svg";